import { DismissDefault16Px, Popover, PositioningImperativeRef, SearchDefault16Px } from '@galaxy-react/core';
import { SyntheticEvent, useEffect, useRef, useState } from 'react';
import ComboboxWithClearButton from './search-use-combobox';
import { AnchorElement, StyledIconButton, StyledPopoverSurface, StyledSearchButton, Wrapper } from './searchbox.styled';

const Searchbox = () => {
  const PLACE_HOLDER = 'Search reports';
  const anchorRef = useRef<HTMLDivElement>(null);
  const positioningRef = useRef<PositioningImperativeRef>(null);
  const [open, setOpen] = useState(false);
  const [hasDismiss, setHasDismiss] = useState(false);
  // const [label, setLabel] = useState(PLACE_HOLDER);

  const handleOpen = () => {
    // setLabel(PLACE_HOLDER);
    setOpen(true);
    setHasDismiss(false);
  };

  const handleClose = (optionValue?: string) => {
    // setLabel(optionValue || '');
    setOpen(false);
    setHasDismiss(true);
  };

  const handleClear = (e: SyntheticEvent) => {
    e.stopPropagation();
    // setLabel(PLACE_HOLDER);
    setOpen(false);
    setHasDismiss(false);
  };

  useEffect(() => {
    if (anchorRef.current) {
      positioningRef.current?.setTarget(anchorRef.current);
    }
  }, [anchorRef, positioningRef]);

  return (
    <Wrapper>
      <AnchorElement ref={anchorRef} />
      <StyledSearchButton icon={<SearchDefault16Px />} onClick={handleOpen} as="a" id="reports-global-search">
        {PLACE_HOLDER}
        {hasDismiss ? (
          <StyledIconButton appearance="transparent" icon={<DismissDefault16Px />} onClick={handleClear} />
        ) : null}
      </StyledSearchButton>
      <Popover onOpenChange={(_, data) => setOpen(data.open)} trapFocus open={open} positioning={{ positioningRef }}>
        <StyledPopoverSurface>
          <ComboboxWithClearButton onClose={handleClose} />
        </StyledPopoverSurface>
      </Popover>
    </Wrapper>
  );
};

export default Searchbox;
